import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom';
import { inittodoFB, inittodoFBNoId } from '../redux/actions';
import TodoHeader from './TodoHeader';
import TodoList from './TodoList';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { IoIosArrowDown } from 'react-icons/io';

interface Props {
    genderStyle: string, 
    datalistDisplay: string|any, 
    todos: inittodoFB[], 
    todosNoId: inittodoFBNoId[], 
    uid: string, 
    uem: string,
    vNo: string
}

interface State {
    genderStyle: string,
    lisnUem: string,
    lisnUid: string,
    lisnTodos: inittodoFB[],
    datalistDisplay: string,
    datalistSelected: string
}



class TodoApp extends PureComponent<Props,State> {  
    
    dt: Date;  
    initialTodo: inittodoFBNoId;
    constructor(props: Props, state: State){
        super(props);
        this.dt = new Date();        
        this.initialTodo = {
            createdAt: this.dt.toLocaleString().substring( 0, this.dt.toLocaleString().indexOf(",") ), 
            title: '',  desc: '',  todoId: 0,    
            userId: 1,    completed: 'false',   tags: ''
        };   
        
        state = {
            genderStyle: 'male',
            lisnUem: '',
            lisnUid: '',
            lisnTodos: [],
            datalistDisplay: 'none',
            datalistSelected: props.vNo            
        }      
    }    

    
    componentDidUpdate(prevProps: object){
        if( this.props !== prevProps ){
          this.setState({ ...this.state, lisnUem: this.props.uem, lisnUid: this.props.uid, lisnTodos: this.props.todos, datalistDisplay: 'none', datalistSelected: this.props.vNo });          
        }
    }
    
    componentWillUnmount(){
        this.setState({ genderStyle: 'male',  lisnUem: '',  lisnUid: '',  lisnTodos: [], datalistDisplay: 'none' });
    }    

    render() {
        // const { genderStyle, todos, todosNoId, uid, uem } = this.props;
        const { genderStyle, todos, uid, uem, vNo } = this.props;
        const userName = uem.slice( 0, uem.indexOf('@') );
        // const VNo = window.location.href.slice( window.location.href.indexOf('.web.app')-2, window.location.href.indexOf('.web.app') );

        const handleToggleDatalist = () => {
            const datalistElem = document.getElementById('versions');
            this.setState({ ...this.state, datalistDisplay: datalistElem?.style.display == 'none' ? 'flex' : 'none' });
        }    
        
        const handleSelectDatalist = (val: string) => {
            this.setState({ ...this.state, datalistSelected: val });
            window.location.href = `https://todoapp-22e95-${val}.web.app/reactTodo`;            
        }    


        // this.setState({ ...this.state, datalistDisplay: 'none', datalistSelected: vNo });
        console.log('check', (!uid && !todos) , (!uid.length && !todos.length), uid , todos)
        // if( !uid && !todos ){             
        /*if( (!uid && !todos) || (!uid.length && !todos.length) ){
        // const { genderStyle, Todos, Uid, uem } = this.props;
        // const userName = Uem.slice( 0, Uem.indexOf('@') );
        // if( !Uid && !Todos ){             
            return (
                <div>
                    <h2> {`Welcome new user`} </h2>
                    <p>you need to <Link to='/reactTodoSignUp'> SignUp </Link> to use app </p>
                    <p>if have account <Link to='/reactTodoSignIn'> SignIn </Link> </p>
                </div>
            ) ;
        }*/
        return (
            <main className={`${genderStyle}-main`}> {
                uem ? 
                <div>
                    <h2>
                    <div id='AzTodos'>
                        <h1>AZ Todos</h1> 
                    </div>
                        <p> Welcome Back, <span>{userName}</span> </p>

                        <div style={{marginRight: '0', marginLeft: 'auto', display: 'flex', flexDirection: 'column', gap: '5px', position: 'relative', whiteSpace: 'nowrap'}}>
                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px'}}>
                                <p className='AzTodosHeaderVNo'> {this.state?.datalistSelected||'v1'} </p>
                                <IoIosArrowDown size={'20px'} cursor={'pointer'} onClick={handleToggleDatalist} />
                            </div>
                            <div id="versions" style={{display: this.state?.datalistDisplay||'none', flexDirection: 'column', gap: '8px', padding: '8px', backgroundColor: '#fff', borderRadius: '8px', position: 'absolute', top: '33px', right: '10px'}}>
                                <a href="https://todoapp-22e95-v1.web.app/reactTodo" className='AzTodosHeaderVNoItem' onClick={() => handleSelectDatalist('v1')} >Version 1</a>
                                <a href="https://todoapp-22e95-v2.web.app/reactTodo" className='AzTodosHeaderVNoItem' onClick={() => handleSelectDatalist('v2')} >Version 2</a>
                            </div>
                        </div>
                    </h2>

                    {/* <div id='AzTodos'>
                        <h1>AZ Todos</h1>
                    </div> */}
                    {/* <h2> 
                        Welcome Back, <span>{userName}</span>
                    </h2> */}
                    {/* <TodoHeader todos={todosNoId} uem={uem} initialTodo={this.initialTodo} /> */}
                    <TodoHeader todos={todos} uem={uem} initialTodo={this.initialTodo} />
                    <TodoList todos={todos} uem={uem}/>
                </div> : <div>
                    <h2> {`Welcome new user`} </h2>
                    <p>you need to <Link to='/reactTodoSignUp'> SignUp </Link> to use app </p>
                    <p>if have account <Link to='/reactTodoSignIn'> SignIn </Link> </p>
                </div>
            } </main>
        )
    }
}

// export default TodoApp

let uemListener = '';
const mapStateToProps = (state: any) => {
  const uem = state.firebase.auth.email;
  const uid = state.firebase.auth.uid;
  uemListener = uem;
  const todos = state.firestore.ordered[`User-${uem}`];
  const vNo = window.location.href.indexOf('.web.app') == -1 ? 'v1' : window.location.href.slice( window.location.href.indexOf('.web.app')-2, window.location.href.indexOf('.web.app') );
//   const vNo = window.location.href.indexOf('3000') == -1 ? 'v##' : 'v1';
//   console.log( todos, uid, uem, window.location.href );  
  return{ uem: uem, uid: uid, todos: todos, vNo: vNo }
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((ownProps) => [
    { collection: `User-${ uemListener }`,   orderBy: ["createdAt", "desc"]},
  ])
)(TodoApp);